import { render, staticRenderFns } from "./XCardText.vue?vue&type=template&id=26006fb2"
import script from "./XCardText.vue?vue&type=script&lang=js"
export * from "./XCardText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports